export const convertToBoolean = (value) => {
  const isString = typeof value === 'string'

  if (isString && value === 'true') return true
  if (isString && value === 'false') return false

  return Boolean(value)
}
